import type { UserConfirmationStatus } from './generated/gql-enums';

export const USER_CONFIRMATION_STATUS_ACTIVE = 'ACTIVE' satisfies UserConfirmationStatus;
export const USER_CONFIRMATION_STATUS_PENDING_EMAIL_CONFIRMATION =
  'PENDING_EMAIL_CONFIRMATION' satisfies UserConfirmationStatus;
